/*
 * Smores topbar marquee — seamless infinite scroll.
 *
 * For a -50% translate loop to be gapless, ONE half of the track must be at
 * least as wide as the viewport. So we first clone the message set until it
 * fills the viewport, then duplicate the whole filled track once (two
 * identical halves). Animation speed is normalized to the width so it reads
 * the same regardless of how many copies were needed.
 */
class SmoresTopbar extends HTMLElement {
  connectedCallback() {
    const track = this.querySelector('.smores-topbar__track');
    if (!track || track.dataset.cloned === 'true') return;

    const originals = [...track.children];
    const append = (node) => {
      const clone = node.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    };

    // 1) Fill one "set" to at least the viewport width (so the loop never gaps).
    let guard = 0;
    while (track.scrollWidth < this.offsetWidth && guard < 40) {
      originals.forEach(append);
      guard++;
    }

    const halfWidth = track.scrollWidth;

    // 2) Duplicate the whole filled track once -> two identical halves.
    [...track.children].forEach(append);
    track.dataset.cloned = 'true';

    // 3) Constant speed (~70px/sec) regardless of copy count.
    track.style.animationDuration = Math.max(18, Math.round(halfWidth / 70)) + 's';
  }
}

if (!customElements.get('smores-topbar')) {
  customElements.define('smores-topbar', SmoresTopbar);
}
